import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import HomePage from "./pages/HomePage";
import TerrainsPage from "./pages/TerrainsPage";
import TerrainDetailPage from "./pages/TerrainDetailPage";
import ModelsPage from "./pages/ModelsPage";
import ModelDetailPage from "./pages/ModelDetailPage";
import ConstructionProjectDetailPage from "./pages/ConstructionProjectDetailPage";
import AgencesPage from "./pages/AgencesPage";
import ContactPage from "./pages/ContactPage";
import ProjetConstructionPage from "./pages/ProjetConstructionPage";
import EtapesConstructionPage from "./pages/EtapesConstructionPage";
import MaisonsSurMesurePage from "./pages/MaisonsSurMesurePage";
import MaisonBiosourceePage from "./pages/MaisonBiosourceePage";
import ConseilsPage from "./pages/ConseilsPage";
import NewsletterPage from "./pages/NewsletterPage";
import AProposPage from "./pages/AProposPage";
import MentionsLegalesPage from "./pages/MentionsLegalesPage";
import PolitiqueConfidentialitePage from "./pages/PolitiqueConfidentialitePage";
import CGVPage from "./pages/CGVPage";
import CookiesPage from "./pages/CookiesPage";
import WellnessPage from "./pages/WellnessPage";
import WellnessProductDetailPage from "./pages/WellnessProductDetailPage";

// Компонент для прокрутки наверх при изменении маршрута
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Header />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/nos-terrains" element={<TerrainsPage />} />
          <Route path="/modeles" element={<ModelsPage />} />
          <Route path="/nos-agences" element={<AgencesPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/votre-projet" element={<ProjetConstructionPage />} />
          <Route path="/projet-construction" element={<ProjetConstructionPage />} />
          <Route path="/etapes-construction" element={<EtapesConstructionPage />} />
          <Route path="/votre-maison" element={<ModelsPage />} />
          <Route path="/maisons-sur-mesure" element={<MaisonsSurMesurePage />} />
          <Route path="/maison-biosourcee" element={<MaisonBiosourceePage />} />
          <Route path="/nos-conseils" element={<ConseilsPage />} />
          <Route path="/newsletter" element={<NewsletterPage />} />
          <Route path="/a-propos" element={<AProposPage />} />
          <Route path="/a-propos-la-maison-des-compagnons" element={<AProposPage />} />
          <Route path="/mentions-legales" element={<MentionsLegalesPage />} />
          <Route path="/politique-confidentialite" element={<PolitiqueConfidentialitePage />} />
          <Route path="/cgv" element={<CGVPage />} />
          <Route path="/cookies" element={<CookiesPage />} />
          <Route path="/espace-client" element={<WellnessPage />} />
          <Route path="/saunas-wellness" element={<WellnessPage />} />
          <Route path="/espace-client/:productId" element={<WellnessProductDetailPage />} />
          <Route path="/terrain/:id" element={<TerrainDetailPage />} />
          <Route path="/modele/:id" element={<ModelDetailPage />} />
          <Route path="/projet/:id" element={<ConstructionProjectDetailPage />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
